/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetVoucherInfoBySellIdReportApiRequest } from '../../models/get-voucher-info-by-sell-id-report-api-request';
import { GetVoucherResponseInfoResultApiResult } from '../../models/get-voucher-response-info-result-api-result';

export interface ApiHotelGetVoucherBySellIdPost$Params {
      body: GetVoucherInfoBySellIdReportApiRequest
}

export function apiHotelGetVoucherBySellIdPost(http: HttpClient, rootUrl: string, params: ApiHotelGetVoucherBySellIdPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetVoucherResponseInfoResultApiResult>> {
  const rb = new RequestBuilder(rootUrl, apiHotelGetVoucherBySellIdPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetVoucherResponseInfoResultApiResult>;
    })
  );
}

apiHotelGetVoucherBySellIdPost.PATH = '/api/hotel/GetVoucherBySellId';
